import React from "react";
import { X, Check } from "lucide-react";
import { ABOUT, NOT_LIKE } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function About({ about = ABOUT }) {
  const notRef = useReveal();
  const aboutRef = useReveal();
  return (
    <section className="relative py-24 md:py-28 ocean-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Not like others */}
        <div ref={notRef} className="reveal text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl text-white">
            Ce n'est pas une formation <span className="text-gold">comme les autres</span>
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="glass rounded-2xl p-8 border-l-2 border-l-[#e0464b]/60">
            <h4 className="text-2xl text-white/90 mb-5 flex items-center gap-2">
              <span className="w-7 h-7 rounded-full bg-[#e0464b]/20 flex items-center justify-center">
                <X className="w-4 h-4 text-[#e0464b]" />
              </span>
              Ce n'est PAS
            </h4>
            <ul className="space-y-3">
              {NOT_LIKE.isNot.map((n) => (
                <li key={n} className="flex items-start gap-3 text-white/65">
                  <X className="w-4 h-4 text-[#e0464b] mt-1 shrink-0" />
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="glass rounded-2xl p-8 border-l-2 border-l-[#27ae8f]/60">
            <h4 className="text-2xl text-white mb-5 flex items-center gap-2">
              <span className="w-7 h-7 rounded-full bg-[#27ae8f]/20 flex items-center justify-center">
                <Check className="w-4 h-4 text-[#27ae8f]" />
              </span>
              C'EST
            </h4>
            <ul className="space-y-3">
              {NOT_LIKE.isYes.map((n) => (
                <li key={n} className="flex items-start gap-3 text-white/85">
                  <Check className="w-4 h-4 text-[#27ae8f] mt-1 shrink-0" />
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* About Gilles */}
        <div ref={aboutRef} className="reveal mt-24 grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative flex justify-center">
            <div className="absolute inset-0 m-auto w-3/4 h-3/4 rounded-full bg-[#d4af37]/15 blur-3xl glow-pulse" />
            <img
              src={about.image}
              alt={about.name}
              className="relative w-[340px] rounded-3xl ring-1 ring-white/10 shadow-2xl"
              loading="lazy"
            />
          </div>
          <div>
            <p className="eyebrow text-[#7fd8e8] text-xs mb-3">Qui suis-je</p>
            <h2 className="text-4xl md:text-5xl text-white">{about.name}</h2>
            <p className="mt-2 text-[#f6e3a8]">{about.role}</p>
            <div className="mt-6 space-y-4 text-white/75 leading-relaxed">
              {about.paras.map((p, i) => (
                <p key={i} className={i === 1 ? "text-xl font-[Cormorant_Garamond] italic text-white/90" : ""}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
